// extracted by mini-css-extract-plugin
module.exports = {"input":"value_scaled_input_input__2hNG6","increaseInput":"value_scaled_input_increaseInput__st3DI","decreaseInput":"value_scaled_input_decreaseInput__3FcAN"};